import {Box, VStack} from 'platform/foundation';

import {TestIdProps, suffixTestId} from 'shared/web';

import {WORKSHOP_SECTION_APPEARANCE} from '../constants/workshopSectionAppearance';
import {WorkshopOverviewInteraction} from '../types/WorkshopOverviewInteraction';
import {WorkshopOverviewTileState, WorkshopSection} from '../types/WorkshopOverviewTileConfig';
import {WorkshopOverviewSectionLabel} from './WorkshopOverviewSectionLabel';
import {WorkshopOverviewTileGrid} from './WorkshopOverviewTileGrid';

interface WorkshopOverviewSectionProps extends TestIdProps {
  section: WorkshopSection;
  tiles: WorkshopOverviewTileState[];
  interaction: WorkshopOverviewInteraction;
}

export function WorkshopOverviewSection(props: WorkshopOverviewSectionProps) {
  const appearance = WORKSHOP_SECTION_APPEARANCE[props.section];

  return (
    <Box
      width="100%"
      height="100%"
      padding={4}
      borderRadius="medium"
      backgroundColor={appearance.backgroundColor}
      data-testid={suffixTestId('workshopOverviewSection', props)}
    >
      <VStack spacing={4} height="100%">
        <WorkshopOverviewSectionLabel
          section={props.section}
          tiles={props.tiles}
          isLoading={props.interaction.isLoading}
          density="comfortable"
          data-testid={props['data-testid']}
        />
        <WorkshopOverviewTileGrid
          section={props.section}
          tiles={props.tiles}
          density="comfortable"
          interaction={props.interaction}
          data-testid={props['data-testid']}
        />
      </VStack>
    </Box>
  );
}
